'use client';
import React, { useState, useEffect } from 'react';

export default function StickyMobileBar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const openSMS = () => {
    const message = 'Hi! I would like to book a car detail appointment.';
    const link = document.createElement('a');
    link.href = `sms:16474500681?body=${encodeURIComponent(message)}`;
    link?.setAttribute('target', '_self');
    document.body?.appendChild(link);
    link?.click();
    document.body?.removeChild(link);
  };

  return (
    <div
      className={`sticky-bar md:hidden transition-all duration-500 ${
        visible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
      }`}
    >
      <div className="flex items-center gap-4">
        <div className="flex-1">
          <p className="text-white text-sm font-700">Ready for a premium interior detail?</p>
          <p className="text-white/50 text-xs font-500">Starting from $99 · Slots available today</p>
        </div>
        <button
          onClick={openSMS}
          className="btn-mint text-sm whitespace-nowrap flex-shrink-0"
        >
          Book My Detail
        </button>
      </div>
    </div>
  );
}